import React from "react";
import MainToolbar from "components/MainToolbar";
import {
  Flex,
  FlexRight,
  HorizontalSpacer,
  NavigationBar,
} from "components/styled";
import { VSpace } from "components/Spacer";
import { Button } from "@fluentui/react-components";
import {
  ArrowImportRegular,
  ArrowSyncCheckmarkRegular,
  CloudArrowDownRegular,
} from "@fluentui/react-icons";
import { ExportExcelHandle } from "./ImportedInvoiceEntriesGrid/ExportExcel";
import { useTranslation } from "react-i18next";
import { useImportedInvoicesStore } from "store/ImportedInvoicesStore";
import { ResultsScore } from "components/ResultsScore";
import { RefreshButton } from "./ImportedInvoicesGrid/RefreshButton";
import ImportedInvoicesMenubar from "./ImportedInvoicesGrid/ImportedInvoicesMenubar";
import { ExportExcelButton } from "./ImportedInvoicesGrid/ExportExcelButton";
import { helpAnchor } from "help/anchor";

type Props = {
  refExcelExport: React.RefObject<ExportExcelHandle>;
};

const Navigation = ({ refExcelExport }: Props) => {
  const { t } = useTranslation();

  const [
    { importedInvoiceMetadataMap, importedInvoicesLoadStatus },
    { setImportedInvoicesStoreValue, setImportedInvoicesStoreValues },
  ] = useImportedInvoicesStore();

  return (
    <>
      <NavigationBar style={{ zIndex: 333 }}>
        <MainToolbar
          pageName={"importedInvoicesPage"}
          dataHelp={helpAnchor("imported-invoices-page-switcher")}
        />
        <RefreshButton />
        <ImportedInvoicesMenubar />
        <VSpace height={5} />
      </NavigationBar>
      <NavigationBar style={{ zIndex: 333 }}>
        <Button
          data-help="imported-invoices-import-button"
          appearance="subtle"
          icon={<ArrowImportRegular />}
          onClick={() => {
            setImportedInvoicesStoreValues({
              importImportedInvoicesDialog: { isOpen: true },
              lastImportResult: null,
            });
          }}
        >
          {t("pct.importImportedInvoices.label")}
        </Button>
        <HorizontalSpacer width={10} />
        <Button
          data-help="imported-invoices-pull-button"
          appearance="subtle"
          icon={<CloudArrowDownRegular />}
          disabled={importedInvoicesLoadStatus === "loading"}
          onClick={() => {
            setImportedInvoicesStoreValues({
              pullImportedInvoicesDialog: { isOpen: true },
              lastPullResult: null,
            });
          }}
        >
          {t("pct.pullImportedInvoices.label")}
        </Button>
        <HorizontalSpacer width={10} />
        <Button
          data-help="imported-invoices-rematch-all-button"
          appearance="subtle"
          icon={<ArrowSyncCheckmarkRegular />}
          disabled={importedInvoicesLoadStatus === "loading"}
          onClick={() => {
            setImportedInvoicesStoreValue("rematchImportedInvoicesDialog", {
              isOpen: true,
              importedInvoiceIds: null,
            });
          }}
        >
          {t("pct.rematchAllImportedInvoices.label")}
        </Button>
        <HorizontalSpacer width={10} />
        <ExportExcelButton refExcelExport={refExcelExport} />
        <FlexRight>
          <Flex>
            <ResultsScore
              dataHelp={helpAnchor("imported-invoices-results-count")}
              score={
                [
                  ...new Map(
                    Object.entries(importedInvoiceMetadataMap)
                  ).values(),
                ].filter((e: any) => {
                  return e.visible === true;
                }).length
              }
            />
          </Flex>
        </FlexRight>
      </NavigationBar>
    </>
  );
};

export default Navigation;
